"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function jsonTryParse(value) {
    var response = {
        value: value,
        isValid: true,
    };
    value = typeof value !== 'string'
        ? JSON.stringify(value)
        : value;
    try {
        value = JSON.parse(value);
    }
    catch (e) {
        response.isValid = false;
    }
    if (response.isValid) {
        if (typeof value === 'object' && value !== null) {
            response.value = value;
            response.isValid = true;
        }
        else {
            response.isValid = false;
        }
    }
    return response;
}
exports.jsonTryParse = jsonTryParse;
function stringifySafe(obj, circularPrefix) {
    if (circularPrefix === void 0) { circularPrefix = '__cache_index_'; }
    var cache = new Map();
    var counter = 0;
    var output = JSON.stringify(obj, function (key, value) {
        if (typeof value === 'object' && value !== null) {
            // Duplicate reference found, return the cache index key
            if (cache.has(value))
                return "" + circularPrefix + cache.get(value);
            // Store value in our cache
            cache.set(value, counter++);
        }
        return value;
    });
    cache = new Map();
    return output;
}
exports.stringifySafe = stringifySafe;
;
//# sourceMappingURL=json.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/utils/json.js
// module id = 241
// module chunks = 1